/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState } from 'react'
import { Spin, Empty } from 'antd'

import { Content, FullHeightSizer } from 'core/screen-util'
import { usePmgrApi, useErrorModal } from './hooks'
import * as api from '../api/report-dashboard'
import DashboardCriteria from './criteria'

import ReportTable from './reportTable'

const EMPTY_OBJECT = {}
const ReportDashboard = () => {
  const [retrieveData, retrievingData] = usePmgrApi(api.retrieveData)
  const [onError, errorModal] = useErrorModal()

  const [maximizedTable, setMaximizedTable] = useState(null)

  const [tableData, setTableData] = useState([])

  const [effectiveData, setEffectiveData] = useState([])

  const [profileData, setProfileData] = useState({})

  const [availableProfiles, setAvailableProfiles] = useState(null)

  const onViewSelectionChange = () => {
    setTableData([])
    setEffectiveData([])
    setProfileData({})
    setAvailableProfiles(null)
    setMaximizedTable(null)
  }

  const retrieve = criteria => {
    retrieveData(criteria).fork(onError, resp => {
      // adding rowIndex in each record
      resp.tables.forEach(table => {
        table.data.forEach((item, index) => {
          item.row = index + 1
        })
      })
      setEffectiveData(resp.tables.map(table => table.data))
      setAvailableProfiles(resp.profiles)
      setTableData(resp.tables)
      setMaximizedTable(null)
    })
  }

  return (
    <Spin spinning={retrievingData}>
      {errorModal}
      <DashboardCriteria
        onRetrieve={retrieve}
        profileData={profileData}
        tableData={tableData}
        effectiveData={effectiveData}
        setProfileData={setProfileData}
        availableProfiles={availableProfiles}
        onViewSelectionChange={onViewSelectionChange}
        setAvailableProfiles={setAvailableProfiles}
      />
      <Content css={{ margin: 0, padding: 5 }}>
        <FullHeightSizer heightOffset={180}>
          {({ height, width }) => (
            <div css={{ height, overflow: 'auto' }}>
              {tableData.length ? (
                tableData.map((table, index) => {
                  return (
                    <ReportTable
                      key={index}
                      table={table}
                      maximizedTable={maximizedTable}
                      setMaximizedTable={setMaximizedTable}
                      effectiveData={effectiveData[index]}
                      setEffectiveData={data => {
                        setEffectiveData(ed =>
                          ed.map((td, i) => {
                            if (index === i)
                              return typeof data === 'function'
                                ? data(td)
                                : data
                            else return td
                          })
                        )
                      }}
                      tableCount={maximizedTable == null ? tableData.length : 1}
                      totalHeight={height}
                      totalWidth={width}
                      profile={profileData[table.tableName] || EMPTY_OBJECT}
                      setProfile={profile =>
                        setProfileData(p => ({
                          ...p,
                          [table.tableName]: profile,
                        }))
                      }
                    />
                  )
                })
              ) : (
                <Empty
                  imageStyle={{ paddingTop: '30px' }}
                  description="Retrieve Data"
                />
              )}
            </div>
          )}
        </FullHeightSizer>
      </Content>
    </Spin>
  )
}

export default ReportDashboard
